(function () {
  function initLinkBanner(banner) {
    banner.querySelectorAll('.section-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        var targetId = this.getAttribute('href').substring(1);
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          var headerEl = document.querySelector(
            '.shopify-section-group-header-group'
          );
          var headerH = headerEl ? headerEl.offsetHeight : 0;
          var top =
            targetElement.getBoundingClientRect().top +
            window.scrollY -
            headerH;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-link-banner]').forEach(initLinkBanner);
    });
  } else {
    document.querySelectorAll('[data-link-banner]').forEach(initLinkBanner);
  }
})();
